export const success = "Success";
export const fileSuccessMessage = "Files in pipeline were successfully loaded";
export const error = "Error";
export const fileErrorMessage = "Files were not uploaded. Please retry";
